/** Where codescreen's source lives. */
export const SOURCE_URL = "https://github.com/fcjr/codescreen.link";
